// All entries here are verified against the existing public/ folder
// and the user's confirmed business facts. NO fabricated data.

export const business = {
  name: 'Cosmik Drones',
  owner: 'Josh Kolonia',
  phone: '610-509-0867',
  phoneHref: 'tel:+16105090867',
  email: 'Josh@cosmikdrones.com',
  emailHref: 'mailto:Josh@cosmikdrones.com',
  city: 'Bethlehem',
  region: 'PA',
  postalCode: '18015',
  country: 'US',
  lat: 40.6084,
  lon: -75.4907,
  url: 'https://cosmikdrones.com',
  faaPart107: true,
  chamberMember: 'Greater Lehigh Valley Chamber of Commerce',
  chamberUrl: 'https://web.lehighvalleychamber.org/Video-Production-and-Drone-Services/Cosmik-Drones-17765',
  social: {
    instagram: 'https://www.instagram.com/josh.kolonia/',
    facebook: 'https://www.facebook.com/josh.kolonia',
    linkedin: 'https://www.linkedin.com/company/cosmik-drones',
  },
};

// Real client list — all currently displayed on the live homepage
// with logos that exist in /public/logos/.
export const clients = [
  { name: 'MLB', logo: '/logos/MLB-Logo.png' },
  { name: 'FanDuel', logo: '/logos/Fanduel.png' },
  { name: 'Home Depot', logo: '/logos/The_Home_Depot_logo-4000x4000.png' },
  { name: 'Lehigh Valley Phantoms', logo: '/logos/Phantoms.png' },
  { name: 'Reading Royals', logo: '/logos/Reading_Royals_logo.svg.png' },
  { name: "Sam's Club", logo: '/logos/Sams_Club.png' },
  { name: 'Four Seasons', logo: '/logos/Four-Seasons-Logo.png' },
  { name: 'Beats by Dre', logo: '/logos/Beats-by-Dre-logo.png' },
  { name: 'Penn Museum', logo: '/logos/Penn-Museum-Logo.png' },
  { name: 'Union League', logo: '/logos/Union League.png' },
  { name: 'Skirmish', logo: '/logos/Skirmish small trans.png' },
  { name: 'Hangdog', logo: '/logos/Hangdog-removebg-preview.png' },
  { name: 'Bikes for Charity', logo: '/logos/B4C_Square_Logo.jpg' },
];

// Showcase pieces — every video file is verified to exist in /public/videos/.
// Categories are factual (commercial / event / fpv / scenery / wedding / sports).
export const showcase = [
  {
    id: 'reel-2024',
    title: '2024 Portfolio Reel',
    category: 'Reel',
    type: 'video',
    src: '/videos/1080 2024 portfolio video.mp4',
    poster: '/images/PD Far.jpg',
    tag: 'Featured',
  },
  {
    id: 'phantoms',
    title: 'Lehigh Valley Phantoms',
    category: 'Sports / Event',
    type: 'video',
    src: '/videos/Phantoms website video.mp4',
    poster: '/images/Phantoms TB toss.jpg',
  },
  {
    id: 'royals',
    title: 'Reading Royals',
    category: 'Sports / Event',
    type: 'video',
    src: '/videos/Royals website video - SOUND.mp4',
    poster: '/images/posters/royals.jpg',
    hasSound: true,
  },
  {
    id: 'velodrome',
    title: 'Valley Preferred Velodrome',
    category: 'Event',
    type: 'video',
    src: '/videos/Velodrome Cycle Website vid.mp4',
    poster: '/images/posters/velodrome.jpg',
  },
  {
    id: 'paving',
    title: 'Commercial Paving',
    category: 'Commercial',
    type: 'video',
    src: '/videos/Paving website video.mp4',
    poster: '/images/posters/paving.jpg',
  },
  {
    id: 'paintball',
    title: 'Skirmish Paintball',
    category: 'Event / Action',
    type: 'video',
    src: '/videos/Paintball quick website vid.mp4',
    poster: '/images/Skirmish paintball photo website.jpg',
  },
  {
    id: 'drift',
    title: 'Drift Day',
    category: 'Event / Action',
    type: 'video',
    src: '/videos/Drift video for website.mp4',
    poster: '/images/posters/drift.jpg',
  },
  {
    id: 'fpv-construction',
    title: 'Indoor FPV — Construction',
    category: 'FPV / Commercial',
    type: 'video',
    src: '/videos/Construction website indoor fpv.mp4',
    poster: '/images/posters/fpv-construction.jpg',
  },
  {
    id: 'fpv-construction-2',
    title: 'Indoor FPV — Walkthrough',
    category: 'FPV / Commercial',
    type: 'video',
    src: '/videos/Construction website indoor fpv 2.mp4',
    poster: '/images/posters/fpv-construction-2.jpg',
  },
  {
    id: 'weddings',
    title: 'Weddings',
    category: 'Wedding',
    type: 'video',
    src: '/videos/weddings website video.mp4',
    poster: '/images/posters/weddings.jpg',
  },
  {
    id: 'scenery',
    title: 'Scenery — Eastern PA',
    category: 'Landscape',
    type: 'video',
    src: '/videos/scenery website quick vid 1.mp4',
    poster: '/images/Fall - Earl Adams - 1.jpg',
  },
];

// Real photographs — every file verified in /public/images/.
export const photos = [
  { src: '/images/Fall - Earl Adams - 1.jpg', alt: 'Aerial fall foliage — Earl Adams', category: 'Landscape' },
  { src: '/images/Fall - Lone Lane - 9.jpg', alt: 'Aerial fall foliage — Lone Lane', category: 'Landscape' },
  { src: '/images/winter photo.jpg', alt: 'Aerial winter landscape', category: 'Landscape' },
  { src: '/images/winter photo 2.jpg', alt: 'Aerial winter landscape', category: 'Landscape' },
  { src: '/images/Phantoms TB toss.jpg', alt: 'Lehigh Valley Phantoms teddy bear toss aerial', category: 'Sports / Event' },
  { src: '/images/MLB.jpg', alt: 'MLB stadium aerial', category: 'Sports / Commercial' },
  { src: '/images/Skirmish paintball photo website.jpg', alt: 'Skirmish paintball aerial', category: 'Event / Action' },
  { src: '/images/W - Police Photo 5.jpg', alt: 'Aerial municipal photography', category: 'Commercial' },
  { src: '/images/Prison.jpg', alt: 'Aerial historic site', category: 'Commercial' },
  { src: '/images/Development map.jpg', alt: 'Aerial development site map', category: 'Real Estate / Construction' },
  { src: '/images/Art museum (3 of 4).jpg', alt: 'Philadelphia Museum of Art aerial', category: 'Commercial' },
  { src: '/images/wedding+2+.jpg', alt: 'Wedding aerial photography', category: 'Wedding' },
  { src: '/images/vinyard+x.jpg', alt: 'Vineyard aerial photography', category: 'Commercial' },
  { src: '/images/Wine.jpg', alt: 'Vineyard aerial', category: 'Commercial' },
  { src: '/images/new+york++mountain.jpg', alt: 'New York mountain aerial', category: 'Landscape' },
  { src: '/images/PD Far.jpg', alt: 'Aerial scenic photograph', category: 'Landscape' },
];

// Full portfolio projects — restored from the original site's own copy
// (titles, clients, locations, descriptions, and deliverables are Josh's
// original wording). Thumbnails that pointed to missing files now use
// frames extracted from each project's actual video.
export const portfolioProjects = [
  {
    id: 'discover-lehigh-valley',
    title: 'Discover Lehigh Valley 2025 Commercial',
    category: 'commercial',
    featured: true,
    thumbnail: '/images/Fall - Lone Lane - 9.jpg',
    video: '/videos/scenery website quick vid 1.mp4',
    description:
      "Official drone cinematography for the Discover Lehigh Valley 2025 tourism campaign, showcasing the region's natural beauty, vibrant communities, and attractions through stunning aerial perspectives.",
    client: 'Discover Lehigh Valley Tourism Board',
    location: 'Lehigh Valley, PA',
    deliverables: 'Promotional Video, Social Media Content, Tourism Campaign',
    externalUrl: 'https://www.discoverlehighvalley.com/',
  },
  {
    id: 'pa-gets-it-done',
    title: 'PA Gets It Done Campaign',
    category: 'commercial',
    featured: true,
    thumbnail: '/images/Fall - Earl Adams - 1.jpg',
    video: '/videos/scenery website quick vid 1.mp4',
    description:
      "Official drone cinematography for Pennsylvania's statewide economic development campaign, showcasing the Commonwealth's innovative industries and business-friendly environment.",
    client: 'Pennsylvania Commonwealth',
    location: 'Statewide, PA',
    deliverables: 'Promotional Video, Aerial Footage, Economic Development Campaign',
    externalUrl: 'https://www.jtwo.tv/portfolio/pa-gets-it-done-2/',
  },
  {
    id: 'skirmish-normandy',
    title: 'Skirmish Paintball: Invasion of Normandy',
    category: 'events',
    thumbnail: '/images/Skirmish paintball photo website.jpg',
    video: '/videos/Paintball quick website vid.mp4',
    description:
      'Dynamic FPV and aerial coverage of the world-renowned Invasion of Normandy scenario event at Skirmish Paintball, capturing the intensity and scale of this massive paintball battle.',
    client: 'Skirmish Paintball',
    location: 'Jim Thorpe, PA (Skirmish Paintball Fields)',
    deliverables: 'Event Highlight Reel, Promotional Footage, Social Media Content',
  },
  {
    id: 'phantoms-media-day',
    title: 'Lehigh Valley Phantoms — Media Day',
    category: 'sports',
    thumbnail: '/images/Phantoms TB toss.jpg',
    video: '/videos/Phantoms website video.mp4',
    description:
      'Dynamic FPV drone coverage of the Lehigh Valley Phantoms Media Day, capturing professional hockey action and fan excitement at the PPL Center.',
    client: 'Lehigh Valley Phantoms',
    location: 'PPL Center — Allentown, PA',
    deliverables: 'Live Event Coverage, Promotional Highlight Reel, Social Media Content',
  },
  {
    id: 'reading-royals',
    title: 'Reading Royals',
    category: 'sports',
    thumbnail: '/images/posters/royals.jpg',
    video: '/videos/Royals website video - SOUND.mp4',
    hasSound: true,
    description:
      'In-arena FPV drone coverage for the Reading Royals professional hockey club.',
    client: 'Reading Royals',
    location: 'Reading, PA',
    deliverables: 'In-Arena FPV Footage, Promotional Content',
  },
  {
    id: 'indoor-fpv-construction',
    title: 'Indoor FPV Construction',
    category: 'commercial',
    thumbnail: '/images/posters/fpv-construction.jpg',
    video: '/videos/Construction website indoor fpv.mp4',
    description:
      'Immersive FPV drone footage capturing interior spaces of construction projects with dynamic movement and impossible transitions.',
    client: 'Home Depot',
    location: 'Allentown, PA',
    deliverables: 'Interior FPV Footage, Progress Documentation, Marketing Content',
  },
  {
    id: 'paving-infrastructure',
    title: 'Paving & Infrastructure',
    category: 'commercial',
    thumbnail: '/images/posters/paving.jpg',
    video: '/videos/Paving website video.mp4',
    description:
      'Aerial documentation of infrastructure projects, highlighting progress and providing valuable oversight of large-scale paving operations.',
    client: 'Richard Diehl Paving & Sons',
    location: 'Easton, PA',
    deliverables: 'Monthly Progress Reports, 3D Mapping, Marketing Assets',
  },
  {
    id: 'drift-coverage',
    title: 'Drift Coverage',
    category: 'sports',
    thumbnail: '/images/posters/drift.jpg',
    video: '/videos/Drift video for website.mp4',
    description:
      'High-octane drone coverage of drift racing events, capturing the speed, smoke, and excitement with dynamic FPV perspectives.',
    client: 'East Coast Drift Series',
    location: 'Evergreen Raceway, PA',
    deliverables: 'Event Highlight Videos, Social Media Content, Promotional Material',
  },
  {
    id: 'velodrome',
    title: 'Lehigh Valley Velodrome',
    category: 'sports',
    thumbnail: '/images/posters/velodrome.jpg',
    video: '/videos/Velodrome Cycle Website vid.mp4',
    description:
      'Professional coverage of cycling events at the velodrome, utilizing dynamic drone movements to follow the action.',
    client: 'Valley Preferred Cycling Center',
    location: 'Trexlertown, PA',
    deliverables: 'Event Highlights, Athlete Profiles, Training Footage',
  },
  {
    id: 'wedding-cinematography',
    title: 'Wedding Cinematography',
    category: 'events',
    thumbnail: '/images/posters/weddings.jpg',
    video: '/videos/weddings website video.mp4',
    description:
      'Breathtaking aerial footage capturing the beauty and emotion of wedding celebrations, from intimate ceremonies to grand receptions.',
    client: 'Various Wedding Clients',
    location: 'Lehigh Valley, PA',
    deliverables: 'Wedding Highlight Films, Aerial Venue Showcases, Social Media Content',
  },
];

export const projectCategories = [
  { id: 'all', name: 'All Projects' },
  { id: 'commercial', name: 'Commercial' },
  { id: 'events', name: 'Events' },
  { id: 'sports', name: 'Sports' },
];

// Featured client collaborations — descriptions from the original site.
export const featuredClients = [
  { name: 'MLB', logo: '/logos/MLB-Logo.png', description: 'Major League Baseball content partnership' },
  { name: 'FanDuel', logo: '/logos/Fanduel.png', description: 'Dynamic event coverage and promotional content' },
  { name: 'Home Depot', logo: '/logos/The_Home_Depot_logo-4000x4000.png', description: 'Commercial and promotional campaigns' },
];

// Local service areas — copy from the original site.
export const serviceAreaCards = [
  { title: 'Allentown', description: "Premium drone services for Allentown's urban landscape, real estate, and corporate events." },
  { title: 'Bethlehem', description: "Capturing Bethlehem's historic charm and modern developments from breathtaking perspectives." },
  { title: 'Easton', description: "Aerial photography and videography highlighting Easton's scenic Delaware riverfront and vibrant community." },
  { title: 'Greater Pennsylvania', description: 'Extending services to Philadelphia, Harrisburg, and throughout the East Coast for special projects.' },
];

// Why choose Cosmik Drones — from the original site, in company voice.
export const whyChoose = [
  { title: 'FAA Certified', description: 'Current Part 107 certification for commercial drone operations.' },
  { title: 'Professional Equipment', description: 'DJI and custom FPV drones for versatile filming options.' },
  { title: 'Creative Excellence', description: 'Artistic vision combined with technical skill to capture stunning aerial perspectives.' },
  { title: 'Quick Turnaround', description: 'Efficient workflow and professional editing for timely project delivery.' },
];

// Instagram reels embedded on the original site.
export const instagramReels = [
  'https://www.instagram.com/josh.kolonia/reel/DJmd0eexkzi/',
  'https://www.instagram.com/josh.kolonia/reel/DJjfZJBxDVj/',
  'https://www.instagram.com/josh.kolonia/reel/DI84oIKx2T9/',
  'https://www.instagram.com/josh.kolonia/reel/DG6VAUPRQpj/',
  'https://www.instagram.com/josh.kolonia/reel/DCmK6M7x1K6/',
  'https://www.instagram.com/josh.kolonia/reel/DAvv4y9PWi2/',
];

// Verified projects mentioned on the existing site
export const projects = [
  {
    id: 'pa-gets-it-done',
    title: 'PA Gets It Done',
    role: 'Aerial cinematography',
    partners: 'Red House Communications · JTWO',
    summary:
      'Statewide campaign for the Pennsylvania Commonwealth highlighting agriculture, energy, life sciences, manufacturing, and technology sectors.',
    url: 'https://www.jtwo.tv/portfolio/pa-gets-it-done-2/',
  },
  {
    id: 'discover-lehigh-valley',
    title: 'Discover Lehigh Valley',
    role: 'Aerial cinematography',
    partners: 'Discover Lehigh Valley',
    summary:
      'Tourism campaign showcasing Lehigh Valley destinations from the air for the regional tourism board.',
    url: null,
  },
];

// Service definitions — every claim is verifiable from the assets above
// (the user has actually shot work in each of these categories).
export const services = [
  {
    slug: 'commercial-drone-production',
    name: 'Commercial Drone Production',
    short: 'Brand films, ad spots, and B-roll',
    cardImage: '/images/posters/paving.jpg',
    blurb:
      'Aerial cinematography for commercials, brand spots, and corporate video. Camera-ready footage in cinematic codecs, ready for your editor or finished in-house.',
    keywords: 'commercial drone production, drone videography, aerial cinematography, brand video drone, commercial video Lehigh Valley',
    primaryVideo: '/videos/Paving website video.mp4',
    examples: ['paving', 'royals', 'phantoms', 'fpv-construction'],
    deliverables: [
      '4K and 5.4K aerial footage',
      'D-Log / D-Cinelike color profiles',
      'Same-day field proxies on request',
      'Storyboard and shot-list collaboration',
      'Insurance certificate (COI) provided to clients',
    ],
    audiences: ['Ad agencies', 'In-house marketing teams', 'Production companies', 'PR firms'],
  },
  {
    slug: 'event-drone-coverage',
    name: 'Event Drone Coverage',
    short: 'Concerts, sports, festivals, races',
    cardImage: '/images/Phantoms TB toss.jpg',
    blurb:
      'Live event aerial coverage with FAA Part 107 compliance and a track record on professional sports, concerts, and large-format outdoor events.',
    keywords: 'event drone coverage, concert drone, sports drone, festival drone, drone videographer Pennsylvania',
    primaryVideo: '/videos/Phantoms website video.mp4',
    examples: ['phantoms', 'royals', 'velodrome', 'paintball', 'drift'],
    deliverables: [
      'Multi-pass aerial coverage',
      'Crowd-safe flight planning',
      'On-site spotter and operator',
      'Edited highlight reel option',
      'Files turned around within agreed deadline',
    ],
    audiences: ['Sports teams', 'Event producers', 'Venues', 'Sponsors'],
  },
  {
    slug: 'real-estate-drone',
    name: 'Real Estate Aerial',
    short: 'Listings, developments, large parcels',
    cardImage: '/images/Development map.jpg',
    blurb:
      'Aerial photography and video for residential listings, commercial properties, and development parcels across the Lehigh Valley and Eastern PA.',
    keywords: 'real estate drone, aerial real estate photography, drone real estate Lehigh Valley, property drone',
    primaryVideo: null,
    primaryImage: '/images/Development map.jpg',
    examples: [],
    photoIds: ['/images/Development map.jpg', '/images/0006.jpg', '/images/0009.jpg', '/images/patio+(1+of+1).jpg'],
    deliverables: [
      'High-resolution still gallery',
      'Cinematic walkaround video',
      'Top-down site map for parcel context',
      'MLS-ready file delivery',
    ],
    audiences: ['Real estate agents', 'Developers', 'Architects', 'Property managers'],
  },
  {
    slug: 'fpv-drone-filming',
    name: 'FPV Drone Filming',
    short: 'Cinewhoop interiors, freestyle moves',
    cardImage: '/images/posters/fpv-construction.jpg',
    blurb:
      'First-person-view drone work for shots a traditional drone cannot make — flowing through interiors, dives, proximity, and immersive action passes.',
    keywords: 'FPV drone, FPV cinewhoop, indoor drone filming, freestyle drone, FPV drone Pennsylvania',
    primaryVideo: '/videos/Construction website indoor fpv.mp4',
    examples: ['fpv-construction', 'fpv-construction-2', 'paintball', 'drift'],
    deliverables: [
      'Cinewhoop and freestyle FPV options',
      'Indoor and tight-space passes',
      'Stabilized in post for delivery',
      'On-site rehearsal of the shot path',
    ],
    audiences: ['Production companies', 'Real estate developers', 'Brands', 'Event producers'],
  },
  {
    slug: 'aerial-photography',
    name: 'Aerial Photography',
    short: 'Stills, top-downs, hero frames',
    cardImage: '/images/Fall - Earl Adams - 1.jpg',
    blurb:
      'High-resolution aerial photography across the East Coast — landscapes, properties, events, and scouting top-downs.',
    keywords: 'aerial photography, drone photography, drone photographer Lehigh Valley, aerial photo Pennsylvania',
    primaryVideo: null,
    primaryImage: '/images/Fall - Earl Adams - 1.jpg',
    examples: [],
    photoIds: [
      '/images/Fall - Earl Adams - 1.jpg',
      '/images/Fall - Lone Lane - 9.jpg',
      '/images/winter photo.jpg',
      '/images/PD Far.jpg',
      '/images/Art museum (3 of 4).jpg',
    ],
    deliverables: [
      'RAW + edited JPG delivery',
      'Multi-altitude coverage on every shot',
      'Top-down orthos available',
      'Color-graded final files',
    ],
    audiences: ['Marketing teams', 'Tourism boards', 'Magazines', 'Architects'],
  },
  {
    slug: 'construction-drone',
    name: 'Construction & Site Documentation',
    short: 'Progress, site mapping, inspection',
    cardImage: '/images/posters/fpv-construction-2.jpg',
    blurb:
      'Indoor FPV walk-throughs and outdoor aerial site documentation for construction, paving, and infrastructure projects.',
    keywords: 'construction drone, drone site documentation, paving drone, infrastructure drone Pennsylvania',
    primaryVideo: '/videos/Construction website indoor fpv 2.mp4',
    examples: ['fpv-construction-2', 'fpv-construction', 'paving'],
    deliverables: [
      'Outdoor aerial progress photography',
      'Indoor FPV walk-throughs',
      'Repeatable shoot positions for monthly progress',
      'High-res top-down for site context',
    ],
    audiences: ['General contractors', 'Developers', 'Civil engineering firms', 'Asset owners'],
  },
];

export const serviceAreas = [
  {
    name: 'Lehigh Valley',
    cities: ['Allentown', 'Bethlehem', 'Easton', 'Emmaus', 'Nazareth'],
  },
  {
    name: 'Greater Pennsylvania',
    cities: ['Philadelphia', 'Reading', 'Harrisburg', 'Pocono Mountains', 'Lancaster'],
  },
  {
    name: 'East Coast',
    cities: ['New Jersey', 'New York', 'Maryland', 'Delaware'],
  },
];

export const equipment = [
  {
    name: 'DJI Mavic 2 Pro',
    role: 'Aerial photography & cinematography',
    image: '/images/Drone/Mavic2.png',
    notes: '1-inch Hasselblad sensor, D-Log color',
  },
  {
    name: 'Cinelog 30',
    role: 'Indoor FPV cinewhoop',
    image: '/images/Drone/Cinelog30.png',
    notes: 'HD video, prop guards for safe interior flight',
  },
  {
    name: 'FPV Freestyle (custom)',
    role: 'Action / dynamic passes',
    image: '/images/Drone/IMG_20230417_144550_120.jpg',
    notes: 'Built for proximity, dives, and high-speed work',
  },
  {
    name: 'Skyeliner',
    role: 'Long-range cinematic',
    image: '/images/Drone/Skyeliner.png',
    notes: 'Extended flight times for sweeping landscape shots',
  },
  {
    name: 'Squirt v2',
    role: 'Tight-space FPV',
    image: '/images/Drone/Squirt v2.png',
    notes: 'Ultra-small for unique perspectives',
  },
  {
    name: 'Professional Setup',
    role: 'Flight control & monitoring',
    image: '/images/Drone photo.jpg',
    notes: 'Complete professional control systems and monitoring equipment for precise flight control',
  },
];

// FAQs that map to actual business facts — used in page copy and JSON-LD schema.
export const faqs = {
  general: [
    {
      q: 'Are you FAA certified?',
      a: 'Yes. Cosmik Drones operates under FAA Part 107 for commercial drone work, with current certification on file.',
    },
    {
      q: 'What areas do you serve?',
      a: 'Cosmik Drones is based in Bethlehem, PA and primarily serves the Lehigh Valley, including Allentown, Bethlehem, and Easton. We regularly travel throughout Pennsylvania and the wider East Coast for commercial and event work.',
    },
    {
      q: 'Do you carry drone insurance?',
      a: 'Yes. A certificate of insurance can be provided to clients and venues on request.',
    },
    {
      q: 'How do I get a quote?',
      a: 'Use the contact form, call 610-509-0867, or email Josh@cosmikdrones.com with the date, location, and a short description of the project.',
    },
    {
      q: 'How quickly can you turn footage around?',
      a: 'Raw and lightly graded files are typically delivered within a few business days. Edited highlight reels follow a project-specific schedule agreed up front.',
    },
  ],
  commercial: [
    {
      q: 'Do you provide a COI for the production?',
      a: 'Yes. We provide a certificate of insurance naming the production company and any additional insureds required by venues or municipalities.',
    },
    {
      q: 'Can you deliver in D-Log or a flat profile?',
      a: 'Yes. Footage is captured in flat color profiles such as D-Log or D-Cinelike for grading in post.',
    },
    {
      q: 'Can you operate as part of a larger crew?',
      a: 'Yes. We work alongside production crews, follow call sheets, and coordinate with the director of photography on shot lists.',
    },
  ],
  event: [
    {
      q: 'Can you fly during a live event with a crowd present?',
      a: 'Yes. All flight planning follows FAA Part 107 rules and event-specific safety constraints, including any required waivers and operator-plus-spotter protocols.',
    },
    {
      q: 'Do you handle sports venues?',
      a: 'Yes — recent work includes the Lehigh Valley Phantoms and Reading Royals, both inside professional ice hockey venues.',
    },
  ],
  realEstate: [
    {
      q: 'Can you deliver photos that work for MLS?',
      a: 'Yes. Files are delivered in MLS-friendly resolutions and aspect ratios, alongside high-resolution masters for marketing.',
    },
  ],
  fpv: [
    {
      q: 'Can FPV drones safely fly indoors?',
      a: 'Yes. We use cinewhoop-style FPV drones with prop guards designed for indoor and tight-space cinematography.',
    },
  ],
};
